import React from 'react'
import HintPopover from "../../../../hint-popover/hint-popover"
import CheckBox, {CheckboxSize, CheckboxType} from "../../../../../gd-components/checkbox/checkbox"
import ProjectSession from "../../../../../model2/project/project-session"
import ProjectIconUI5 from "../../../../../gd-components/icons/project/project-icon-ui5";
import {ItemDisplay} from "../../../../../model2/item/@type";

type Props = {
    style?                      : style
    project                     : ProjectSession
    level?                      : number
    selectedProjects            : ID[]

    multiselectCheckboxType?    : CheckboxType

    inheritedChildrenSelection  : boolean
    isParentSelected?           : boolean
    colorized?                  : boolean

    onSelect                    : callback
    onMenuItemHandleClick?      : callback
}

type State = {
    useHint: boolean,
    hovered: boolean,
}

// const debug = "ProjectTree_MultiItem"
const debug = false

export default class ProjectTree_MultiItem extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props);

        this.state = {
            useHint: false,
            hovered: false
        };

    }

    onClick = (e:React.SyntheticEvent) => {

        if (this.props.project.treeDisplay !== ItemDisplay.VISIBLE) {

            if (this.props.project.treeHasVisibleChildren) {
                this.onArrowClick(e)
            }

            return
        }


        this.props.onSelect(this.props.project.id)
    };

    onArrowClick = (e: React.SyntheticEvent) => {
        e.stopPropagation()
        this.props.onMenuItemHandleClick?.(this.props.project)
    }

    render() {
        if (!this.props.project) {
            console.error("ERROR #kdjdjh24 - how come no project found - onProjectDelete ?")
            return null
        }

        const project = this.props.project;

        debug && console.log(debug, 'render', gd.layout.contextMenu.hover?.component?.props.project.id, this.props.project.id, gd.layout.contextMenu.hover)

        // Do not display hidden at all
        if (this.props.project.treeDisplay === ItemDisplay.HIDDEN) {
            return null
        }

        if (gd.layout.contextMenu.isShown && gd.layout.contextMenu.hover!.component.props.project.id === this.props.project.id) {
            gd.layout.contextMenu.hover!.component = this
        }

        const isSelected            = this.props.selectedProjects.includes(this.props.project.id)
        const isSelectionInherited  = this.props.inheritedChildrenSelection && this.props.isParentSelected
        const isCheckboxSelected    = isSelectionInherited || isSelected

        const isHovered             = this.state.hovered || gd.layout.contextMenu.hover?.component?.props.project?.id === this.props.project.id
        const isDisabled            = project.treeIsGhost || isSelectionInherited

        const classes = Classes('item project', 'level-'+this.props.level, 'projectId-'+this.props.project.id /*required for scroll to node*/, {
            'selected'  : isSelected,
            'hovered'   : isHovered,
            'disabled'  : isDisabled
        })

        const hasVisibleChildren = project.treeHasVisibleChildren

        const arrowClasses = Classes("arrow", {
            "hidden"    : !hasVisibleChildren,
            "closed"    : !this.props.project.treeIsExpandedProjectSelector,
            "open"      : this.props.project.treeIsExpandedProjectSelector
        })

        return (
            <div className={classes} style={this.props.style} onClick={isDisabled ? undefined : this.onClick}>
                <div className="row p-l-10">
                    <CheckBox className = "flex-no-shrink"
                              type      = {this.props.multiselectCheckboxType}
                              size      = {CheckboxSize.SMALL}
                              isChecked = {isCheckboxSelected}
                              disabled  = {isDisabled}
                              onClick   = {this.onClick}/>

                    <div className={arrowClasses} onClick={this.onArrowClick}/>

                    <ProjectIconUI5 className   = "icon"
                                    projectId   = {this.props.project.id}
                                    colorize    = {this.props.colorized}
                                    isExpanded  = {hasVisibleChildren && this.props.project.treeIsExpandedProjectSelector}/>

                    <div className="name">{this.props.project.name}</div>
                </div>

                {this.state.useHint &&
                    <HintPopover parent={this} hint={this.props.project.name} multiline={true}/>
                }
            </div>
        );
    }
}
